const bodyPartCoordinates = [
  {
    top: 5,
    left: 84,
    type: '1',
  },
  {
    top: 100,
    left: 84,
    type: '2',
  },
  {
    top: 70,
    left: 140,
    type: '3',
  },
  {
    top: 70,
    left: 30,
    type: '4',
  },
  {
    top: 170,
    left: 84,
    type: '5',
  },
  {
    top: 150,
    left: 16,
    type: '6',
  },
  {
    top: 150,
    left: 150,
    type: '7',
  },
  {
    top: 240,
    left: 57,
    type: '8',
  },
  {
    top: 240,
    left: 110,
    type: '9',
  },
  {
    top: 330,
    left: 57,
    type: '10',
  },
  {
    top: 330,
    left: 110,
    type: '11',
  },
];

export default bodyPartCoordinates;
